import { NodeDefinition } from 'Automations/nodeDefinitions/types'
import { ActionPublishQuoteNodeConfigForm } from './actionPublishQuote.configForm'
import { ActionEditorNode } from '../action.editorNode'
import { ActionIcon } from '../action.icon'
import { ActionType } from '..'
import {
  createSimpleTask,
  getTaskReferenceName,
  wrapVariables
} from 'Automations/nodeDefinitions/conductor'
import {
  getClosestMatches,
  semanticTypes
} from 'Automations/nodeDefinitions/semanticTypes'
import { actionTypeRequired, handlesConnected } from '../action.validators'
import { PublishQuoteExecutionSummary } from './PublishQuote.executionSummary'
import { TASK_EXECUTORS } from 'Automations/automations.constants'

export type Config = {
  name: string
  actionType: ActionType
}

type Inputs = 'signatureConfiguration' | 'quote'

type TaskName = 'publishQuote'

const taskReferenceBuilder = getTaskReferenceName<TaskName>(
  'ACTION_PUBLISH_QUOTE'
)

export const actionPublishQuoteNodeDefinition: NodeDefinition<Config, Inputs> =
  {
    name: 'Action',
    description: 'Publish quote',
    editorNode: ActionEditorNode,
    configForm: ActionPublishQuoteNodeConfigForm,
    icon: ActionIcon,
    defaultConfig: {
      name: '',
      actionType: 'PUBLISH_QUOTE'
    },
    validation: {
      node: { ERROR: [], WARN: [] },
      config: {
        name: { ERROR: [], WARN: [] },
        actionType: { ERROR: [actionTypeRequired], WARN: [] }
      },
      handles: { ERROR: [handlesConnected], WARN: [] }
    },
    inputMapping: ({ upstreamNodes }) => {
      return getClosestMatches<Inputs>(upstreamNodes)({
        quote: semanticTypes.sequence.quote.quote,
        signatureConfiguration:
          semanticTypes.sequence.quoteApproval.signatureConfiguration
      })
    },
    taskTransformer: ({ nodeId, inputMapping }) => {
      const taskReferenceName = taskReferenceBuilder(nodeId)

      return [
        createSimpleTask({
          name: 'update_sequence_data',
          taskReferenceName: taskReferenceName('publishQuote'),
          inputParameters: {
            taskExecutorConfiguration: {
              executor: TASK_EXECUTORS.publishQuote,
              version: 1
            },
            data: wrapVariables({
              quoteId: `${inputMapping.quote}.id`,
              signatureConfiguration: inputMapping.signatureConfiguration
            })
          }
        })
      ]
    },
    executionSummary: PublishQuoteExecutionSummary
  }
